import { render, staticRenderFns } from "./TextTab.vue?vue&type=template&id=c2af36de&"
import script from "./TextTab.vue?vue&type=script&lang=js&"
export * from "./TextTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports